"use client";

import { useState } from "react";

/** Prefer compact WebP for orbit cards when a `-card.webp` sibling exists. */
function cardImageUrl(imageUrl?: string): string | undefined {
  if (!imageUrl) return undefined;
  // CMS proxy covers — do not invent a missing -card.webp sibling
  if (imageUrl.includes("/api/blog-cover/")) return imageUrl;
  const m = imageUrl.match(/^(.*\/blog\/[^/?#]+?)(?:-card)?\.(jpe?g|png|webp)([?#].*)?$/i);
  if (!m) return imageUrl;
  return `${m[1]}-card.webp${m[3] ?? ""}`;
}

export function BlogCardMedia({
  imageUrl,
  title,
  priority = false,
}: {
  imageUrl?: string;
  title: string;
  priority?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  const preferred = cardImageUrl(imageUrl);
  const src = failed ? imageUrl : preferred;
  const showImage = Boolean(src);

  return (
    <div className="blog-card-media">
      {showImage ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={src}
          alt=""
          className="blog-card-img"
          loading={priority ? "eager" : "lazy"}
          decoding="async"
          fetchPriority={priority ? "high" : "low"}
          draggable={false}
          width={200}
          height={125}
          sizes="(max-width: 860px) 45vw, 200px"
          onError={() => {
            if (!failed && preferred !== imageUrl) setFailed(true);
          }}
        />
      ) : (
        <span className="blog-card-placeholder" aria-hidden>
          <span className="blog-card-placeholder-text">{title}</span>
        </span>
      )}
    </div>
  );
}
